<template>
  <div class="grid grid-cols-2 col-gap-14 row-gap-4">
    <div class="col">
      <h1>River Sections</h1>
    </div>
    <div>
      <base-button-success class="float-right" @click="showModal = true"
        >Add a river section</base-button-success
      >
    </div>

    <div class="mb-3 col-span-2">
      <div class="w-full">
        <el-table
          :data="outfitterRivers"
          :default-sort="{ prop: 'name', order: 'ascending' }"
          style="width: 100%"
        >
          <el-table-column label="Name" sortable style="width: 80%">
            <template slot-scope="scope">
              {{ scope.row.river.name }} - {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <base-button-primary-extra-small
                @click="handleRemove(scope.row)"
                class="float-right mr-3"
              >
                Remove
              </base-button-primary-extra-small>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <base-modal :show="showModal" @close="showModal = false" @save="save">
      <template v-slot:header> Add River Section</template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4 mb-40">
          <div>
            <base-label>River</base-label>
            <base-select
              ref="riverSelect"
              :options="rivers"
              @input="handleRiverSelect"
            ></base-select>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseButtonSuccess from "@/components/ui/buttons/BaseButtonSuccess";
import BaseSelect from "@/components/ui/forms/BaseSelect";
export default {
  name: "DashboardRivers",
  components: { BaseSelect, BaseButtonSuccess },
  data() {
    return {
      showModal: false,
      selectedSection: null,
    };
  },
  methods: {
    handleRemove(row) {
      this.$store
        .dispatch("outfitter/remove_river_section", {
          id: row.id,
          outfitterId: this.$store.getters["auth/outfitterId"],
        })
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch(
            "outfitter/reload_outfitter",
            this.$store.getters["auth/outfitterId"]
          );
        });
    },
    save() {
      this.$store
        .dispatch("outfitter/add_river_section", {
          id: this.selectedSection,
          outfitterId: this.$store.getters["auth/outfitterId"],
        })
        .then((resp) => {
          if (!resp.success) return;

          this.selectedSection = null;
          this.showModal = false;
          this.$store.dispatch(
            "outfitter/reload_outfitter",
            this.$store.getters["auth/outfitterId"]
          );
        });
    },
    handleRiverSelect(sectionId) {
      this.selectedSection = sectionId;
    },
  },
  computed: {
    outfitterRivers: function () {
      const outfitter = this.$store.getters["outfitter/getOutfitter"];
      return outfitter.river_sections;
    },
    rivers: function () {
      let rivers = this.$store.getters["river/getRivers"];
      let arr = rivers
        .map((river) => {
          return river.river_sections.map((section) => {
            return {
              value: section.id,
              label: river.name + " - " + section.name,
            };
          });
        })
        .flat();
      return arr;
    },
  },
  mounted() {
    this.$store.dispatch("river/all", { withDeleted: false });
  },
};
</script>
